import type { CommandAction } from '../../../types/CommandAction.js';
import { getNonSemverDeps } from './getNonSemverDeps.js';

export interface NonSemverDepsOptions {
  /** Only get production deps */
  prod?: boolean;
}

/** Executor for the "info non-semver-deps" verb */
export const execute: CommandAction<NonSemverDepsOptions> = async (params) => {
  const { options, appPath: cwd } = params;

  try {
    return {
      message: await getNonSemverDeps({ ...options, cwd }),
    };
  } catch (err) {
    return {
      message: `Error attempting to get non-semver deps: ${(err as Error).stack || err}`,
      hasErrors: true,
    };
  }
};
